<template>
    <span class="block-control">
        <img class="block-control__btn" @click="start" v-if="state === states.pause" src="@/assets/icons/play.svg" />
        <img class="block-control__btn" @click="pause" v-if="state === states.run" src="@/assets/icons/pause.svg" />
    </span>
</template>

<script>
    import { mapState, mapActions } from 'vuex'

    export default {
        computed: {
            ...mapState('control', ['state', 'states'])
        },
        methods: {
            ...mapActions('control', ['pause', 'start'])
        }
    }
</script>

<style lang="stylus" scoped>
    .block-control {
        &__btn {
            width 3rem
            height @width
        }
    }
</style>
